import { createSlice } from "@reduxjs/toolkit";
import { getCategoriesThunk, getFileClinetsThunk, getFileUsersThunk, addCategoryThunk, addFileUserLevelThunk, addFileClientLevelThunk } from "./filesThunk";

const initialState = {
    status: "idle",
    error: null,
    success: "",
    getCategories: [],
    getFileUsers: [],
    getFileClients: [],
};

const fileCategoriesSlice = createSlice({
    name: "fileCategories",
    initialState,
    reducers: {
        resetFileState: (state, action) => {
            state.status = "idle";
            state.error = null;
            state.success = "";
        }
    },
    extraReducers: (builder) => {
        builder
            // getCategoriesThunk
            .addCase(getCategoriesThunk.pending, (state) => {
                state.status = "loading";
                state.error = null;
            })
            .addCase(getCategoriesThunk.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.success = action.payload?.success;
                state.error = null;
                state.getCategories = action.payload;
            })
            .addCase(getCategoriesThunk.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.payload || "Login failed";
                state.success = "";
            })

            // getFileClinetsThunk
            .addCase(getFileClinetsThunk.pending, (state) => {
                state.status = "loading";
                state.error = null;
            })
            .addCase(getFileClinetsThunk.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.success = action.payload?.success;
                state.error = null;
                state.getFileClients = action.payload;
            })
            .addCase(getFileClinetsThunk.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.payload || "Login failed";
                state.success = "";
            })

            // getFileUsersThunk
            .addCase(getFileUsersThunk.pending, (state) => {
                state.status = "loading";
                state.error = null;
            })
            .addCase(getFileUsersThunk.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.success = action.payload?.success;
                state.error = null;
                state.getFileUsers = action.payload;
            })
            .addCase(getFileUsersThunk.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.payload || "Login failed";
                state.success = "";
            })

            // Add the Category
            .addCase(addCategoryThunk.pending, (state) => {
                state.status = "loading";
                state.error = null;
            })
            .addCase(addCategoryThunk.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.success = action.payload.success;
                state.error = null;
            })
            .addCase(addCategoryThunk.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.payload || "Login failed";
                state.success = "";
            })


            // Add the userLevel
            .addCase(addFileUserLevelThunk.pending, (state) => {
                state.status = "loading";
                state.error = null;
            })
            .addCase(addFileUserLevelThunk.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.success = action.payload.success;
                state.error = null;
            })
            .addCase(addFileUserLevelThunk.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.payload || "Login failed";
                state.success = "";
            })

            // Add the Client Level
            .addCase(addFileClientLevelThunk.pending, (state) => {
                state.status = "loading";
                state.error = null;
            })
            .addCase(addFileClientLevelThunk.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.success = action.payload.success;
                state.error = null;
            })
            .addCase(addFileClientLevelThunk.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.payload || "Login failed";
                state.success = "";
            })
    },
});

export const { resetFileState } = fileCategoriesSlice.actions;
export default fileCategoriesSlice.reducer;